import type { Board } from "../board";
import { ALL_DIRECTIONS, directionDelta } from "../direction";
import { DirectionalSlash3Tile } from "../effects/directionalSlash3Tile";
import { PRIORITY_DEFAULT, type ProcessableThing } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

// Dev/QA fixture, sibling of DummyMob in spirit — drop one in the playground
// and edit processTurn to fire whichever effect is currently under inspection.
// Current configuration: emits a DirectionalSlash3Tile 2 cells away in each of the
// 8 directions every turn, so all direction-rotated variants can be seen at once.
export class EffectTester extends PhysicalThing implements ProcessableThing {
	static key = "EffectTester";

	constructor(xy: XY) {
		super(xy, false);
	}

	processTurn(board: Board): void {
		for (const dir of ALL_DIRECTIONS) {
			const delta = directionDelta(dir);
			const target = this.xy.add(delta.x * 2, delta.y * 2);
			if (!board.isInBounds(target)) continue;
			board.addEffect(new DirectionalSlash3Tile(target, dir));
		}
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	static deserialize(data: any): EffectTester {
		const tester = new EffectTester(deserializeXY(data.xy));
		tester.visualId = data.visualId;
		return tester;
	}
}
